import React, { useContext } from 'react';
import { LanguageContext } from '../index/content';

function Footer() {

    const {language, setLanguage} = useContext(LanguageContext)

    return (
            <footer class="container-fluid">
                <div class="row">
                    <div class="wrapper">
                        <div class="col-lg-12">
                            <div class="row justify-content-end">
                                <div class="col-lg-3">
                                    <div class="row">
                                        <div class="footer-content">
                                            <p class="link-email"><a href="mailto:airsoft@sureshot-armament.com">airsoft@sureshot-armament.com</a></p>
                                            <p><button onClick={()=>setLanguage('eng')}>ENG</button> <button onClick={()=>setLanguage('rus')}>RUS</button></p>
                                            <p>©2023 SURESHOT ARMAMENT GROUP</p>
                                            <p><a href="https://sureshot-armament.com/terms-and-conditions/">{language == 'eng' ? 'Terms and conditions' : 'Условия и положения'}</a></p>
                                            <p><a href="https://sureshot-armament.com/privacy-policy/">{language == 'eng' ? 'Privacy Policy' : 'Политика конфиденциальности'}</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            )
}

export default Footer
